import MegaMenu from '../__header/MegaMenu';
import MobileHeader from '../__header/mobileHeader';
import Accordion from '../__shortcodes/accordions';
import Tabs from '../__page/tabs';
import GalleryLightbox from '../__page/lightboxGallery';
import LighboxVideo from '../__page/lightboxVideo';
import bindScrollEvents from '../__utils/lockScroll';
import Video from '../__utils/video';
import { SimpleSlider, LightboxSlider } from '../__utils/sliders';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import NextSteps from '../__header/nextStepsMenu';
import FixedHeader from '../__header/fixedHeader';
import AjaxFilters from '../__letters/ajaxFilters';
import Transitions from '../__utils/elementsTransition';
import ChangeProgram from '../__page/ChangeProgram';
import HomepageInit from '../__page/HomepageInit';
import { ScrollableLetters, dragScroll } from '../__page/ScrollableLetters';
import HomepageVideoHeight from '../__page/HomepageVideoHeight'

const headerMobile = new MobileHeader();

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
        MegaMenu.init();
        headerMobile.init();
        Accordion.init();
        Tabs.init();
        ChangeProgram.init();
        bindScrollEvents();
        Video();
        SimpleSlider.init();
        LightboxSlider.init();
        GalleryLightbox.init();
        LighboxVideo.init();
        smoothScroll();
        NextSteps.init();
        Tables.init();
        AjaxFilters.init();
        Transitions.makeElTransition();
        ScrollableLetters();
        dragScroll();
    },
    loaded() {
        HomepageInit.init();
        HomepageVideoHeight();
    },
    resized() {
        headerMobile.resized();
        Tables.toggleTablesShadow();
        GalleryLightbox.refreshSlider();
        FixedHeader.updateHederHeight();
        headerMobile.resized();
		HomepageVideoHeight();
    },
    scroll() {
        FixedHeader.scrollFunc();
        headerMobile.resized();
        Transitions.makeElTransition();
    },
};
export default controller;
